module.exports = __webpack_public_path__ + "img/gongzhonghaoCode.9aa0a7bb.png";